import DocumentAPI from './Documents';
import { DocumentURL } from '../../../services/config';

const DOCUMENT_HOST = DocumentURL || '';
export const documents = new DocumentAPI(DOCUMENT_HOST);
